import { CSSProperties } from 'react';

export const mapContainerStyle: CSSProperties = {
    borderRadius: '0.5rem',
    height: '54rem',
    width: '100%',
};
